import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from '@app/store/store';
import { cancelProactiveRefresh, scheduleProactiveRefresh } from '@shared/utils/proactive-token-refresh';

import { logout, setAuthToken, setCredentials } from './authentication.slice';

/**
 * Keeps the proactive-refresh timer in sync with the token lifecycle.
 *
 * Any action that installs a token — `setCredentials` (login / bootstrap / remote LOGIN) or
 * `setAuthToken` (reactive refresh, proactive refresh, or a remote TOKEN_REFRESHED) — reschedules
 * the timer off the new token's `exp`. `logout` (local, inactivity, or cross-tab) cancels it.
 */
export const proactiveRefreshListenerMiddleware = createListenerMiddleware();

const startListening = proactiveRefreshListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startListening({
  matcher: isAnyOf(setCredentials, setAuthToken),
  effect: (_action, listenerApi) => {
    scheduleProactiveRefresh({ dispatch: listenerApi.dispatch, getState: () => listenerApi.getState() });
  },
});

startListening({
  actionCreator: logout,
  effect: () => {
    cancelProactiveRefresh();
  },
});
